"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformCompositeFilter = void 0;
var filter_descriptor_interface_1 = require("./filter-descriptor.interface");
var accessor_1 = require("../accessor");
var utils_1 = require("../utils");
var logic = {
    "or": {
        concat: function (acc, fn) { return function (a) { return acc(a) || fn(a); }; },
        identity: function () { return false; }
    },
    "and": {
        concat: function (acc, fn) { return function (a) { return acc(a) && fn(a); }; },
        identity: function () { return true; }
    }
};
var operatorsMap = {
    contains: function (a, b) { return (a || "").indexOf(b) >= 0; },
    doesnotcontain: function (a, b) { return (a || "").indexOf(b) === -1; },
    doesnotendwith: function (a, b) { return (a || "").indexOf(b, (a || "").length - (b || "").length) < 0; },
    doesnotstartwith: function (a, b) { return (a || "").lastIndexOf(b, 0) === -1; },
    endswith: function (a, b) { return (a || "").indexOf(b, (a || "").length - (b || "").length) >= 0; },
    eq: function (a, b) { return a === b; },
    gt: function (a, b) { return a > b; },
    gte: function (a, b) { return a >= b; },
    isempty: function (a) { return a === ''; },
    isnotempty: function (a) { return a !== ''; },
    isnotnull: function (a) { return (0, utils_1.isPresent)(a); },
    isnull: function (a) { return (0, utils_1.isBlank)(a); },
    lt: function (a, b) { return a < b; },
    lte: function (a, b) { return a <= b; },
    neq: function (a, b) { return a != b; },
    startswith: function (a, b) { return (a || "").lastIndexOf(b, 0) === 0; }
};
var dateRegExp = /^\/Date\((.*?)\)\/$/;
var convertValue = function (value, ignoreCase) {
    if (value != null && (0, utils_1.isString)(value)) {
        var date = dateRegExp.exec(value);
        if (date) {
            return new Date(+date[1]).getTime();
        }
        else if (ignoreCase) {
            return value.toLowerCase();
        }
    }
    else if (value != null && (0, utils_1.isDate)(value)) {
        return value.getTime();
    }
    return value;
};
var typedGetter = function (prop, value, ignoreCase) {
    if (!(0, utils_1.isPresent)(value)) {
        return prop;
    }
    var acc = prop;
    if ((0, utils_1.isString)(value)) {
        var date = dateRegExp.exec(value);
        if (date) {
            value = new Date(+date[1]);
        }
        else {
            acc = function (a) {
                var x = prop(a);
                if (x === null) {
                    return x;
                }
                var stringValue = typeof x === 'string' ? x : x + "";
                return ignoreCase ? stringValue.toLowerCase() : stringValue;
            };
        }
    }
    if ((0, utils_1.isDate)(value)) {
        return function (a) {
            var x = acc(a);
            return (0, utils_1.isDate)(x) ? x.getTime() : x;
        };
    }
    return acc;
};
var transformFilter = function (_a) {
    var field = _a.field, ignoreCase = _a.ignoreCase, value = _a.value, operator = _a.operator;
    field = !(0, utils_1.isPresent)(field) ? function (a) { return a; } : field;
    ignoreCase = (0, utils_1.isPresent)(ignoreCase) ? ignoreCase : true;
    var itemProp = typedGetter((0, utils_1.isFunction)(field) ? field : (0, accessor_1.getter)(field, true), value, ignoreCase);
    value = convertValue(value, ignoreCase);
    var op = (0, utils_1.isFunction)(operator) ? operator : operatorsMap[operator];
    return function (a) { return op(itemProp(a), value, ignoreCase); };
};
/**
 * @hidden
 */
var transformCompositeFilter = function (filter) {
    var combiner = logic[filter.logic];
    return filter.filters
        .filter(utils_1.isPresent)
        .map(function (x) { return (0, filter_descriptor_interface_1.isCompositeFilterDescriptor)(x) ? (0, exports.transformCompositeFilter)(x) : transformFilter(x); })
        .reduce(combiner.concat, combiner.identity);
};
exports.transformCompositeFilter = transformCompositeFilter;



//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-data-query@1.7.1/~/@progress/kendo-data-query/dist/npm/filtering/filter-no-eval.js
// module id = 6412
// module chunks = 0